module.exports = __webpack_public_path__ + "img/9788990809308.1d25dbfd.jpg";